import { useMemo } from 'react'
import { isImageAttachment } from './utils/isImageAttachment'

export function useUserChatBubbleAttachments(attachments) {
  const imageAttachmentsOnly = useMemo(
    () => attachments.filter((f) => isImageAttachment(f)),
    [attachments],
  )

  const imageThumbSizeVariant = useMemo(() => {
    const n = imageAttachmentsOnly.length
    if (n <= 1) return 'single'
    if (n <= 3) return 'few'
    return 'many'
  }, [imageAttachmentsOnly.length])

  const attachmentImageEntries = useMemo(() => {
    const list = []
    let imageRun = 0
    attachments.forEach((file, originalIdx) => {
      if (isImageAttachment(file)) {
        list.push({ file, originalIdx, imageIndex: imageRun })
        imageRun += 1
      }
    })
    return list
  }, [attachments])

  const attachmentDocEntries = useMemo(
    () =>
      attachments
        .map((file, originalIdx) => ({ file, originalIdx }))
        .filter(({ file }) => !isImageAttachment(file)),
    [attachments],
  )

  return {
    imageAttachmentsOnly,
    imageThumbSizeVariant,
    attachmentImageEntries,
    attachmentDocEntries,
  }
}
